import { render, staticRenderFns } from "./BuyList.vue?vue&type=template&id=74cfbd24&scoped=true&"
import script from "./BuyList.vue?vue&type=script&lang=js&"
export * from "./BuyList.vue?vue&type=script&lang=js&"
import style0 from "./BuyList.vue?vue&type=style&index=0&id=74cfbd24&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cfbd24",
  null
  
)

export default component.exports